import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Button,
} from "@mui/material";
import { motion } from "framer-motion";

const haptic = {
    whileTap: { scale: 0.97 },
    whileHover: { scale: 1.03 },
    transition: { type: "spring", stiffness: 300, damping: 17 },
};

export default function SolutionCategory({
    id,
    title,
    description,
    products,
    bgColor = "#fff",
}) {
    return (
        <Box
            id={id}
            sx={{
                bgcolor: bgColor,
                py: { xs: 6, md: 10 },
                scrollMarginTop: "80px",
            }}
        >
            <Container maxWidth="xl">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 800,
                            color: "primary.main",
                            mb: 1,
                            textAlign: "center",
                            letterSpacing: "-0.02em",
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "text.secondary",
                            fontSize: "1.15rem",
                            mb: 5,
                            maxWidth: 800,
                            mx: "auto",
                            textAlign: "center",
                        }}
                    >
                        {description}
                    </Typography>
                </motion.div>

                <Grid container spacing={5} justifyContent="center">
                    {products.map((product, i) => (
                        <Grid item xs={12} md={6} lg={4} key={product.name}>
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                {...haptic}
                                transition={{ duration: 0.5 + i * 0.09 }}
                                style={{ height: "100%" }}
                            >
                                <Card
                                    elevation={3}
                                    sx={{
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        borderRadius: 4,
                                        px: 2,
                                        py: 3,
                                        boxShadow: "0 3px 28px 0 rgba(20,76,100,0.07)",
                                    }}
                                >
                                    {product.logo && (
                                        <CardMedia
                                            component="img"
                                            image={product.logo}
                                            alt={`${product.name} logo`}
                                            sx={{
                                                width: 70,
                                                height: 70,
                                                objectFit: "contain",
                                                borderRadius: 2,
                                                bgcolor: "#e7f5f6",
                                                mb: 2,
                                                mt: 1,
                                            }}
                                        />
                                    )}
                                    <CardContent sx={{ flexGrow: 1, textAlign: "center" }}>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontWeight: 800,
                                                mb: 2,
                                                color: "primary.main",
                                                fontSize: "1.25rem",
                                            }}
                                        >
                                            {product.name}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                color: "text.primary",
                                                mb: 2,
                                                fontSize: "1.09rem",
                                            }}
                                        >
                                            {product.description}
                                        </Typography>
                                    </CardContent>
                                    {product.link && (
                                        <CardActions>
                                            <Button
                                                component={motion.a}
                                                href={product.link}
                                                size="large"
                                                variant="contained"
                                                {...haptic}
                                                sx={{
                                                    fontWeight: 700,
                                                    borderRadius: 99,
                                                    px: 4,
                                                    fontSize: "1.05rem",
                                                    background:
                                                        "linear-gradient(90deg,#145c8c,#21dbb8)",
                                                    color: "#fff",
                                                }}
                                            >
                                                {product.cta || "Learn More"}
                                            </Button>
                                        </CardActions>
                                    )}
                                </Card>
                            </motion.div>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
}
